import {useParams, useRouteMatch} from 'react-router-dom';
import {UserSeniorForm} from '../../../../../../../components/user-form/user-senior-form';
import {UserFormType} from '../../../../../../../enums/user-form-type';
import {UsersRepository} from '../../../../../../../repositories/users';
import {AffiliationInfo} from '../../../../../../../backend/interfaces/affiliation-info';
import {useEffect, useState} from 'react';
import {Stack} from '@mui/material';
import {LoadingContent} from '../../../../../../../components/loading-content/loading-content';

export default function SeniorProfileSystemAdministratorOfficeScreen() {
  let {id}: {id?: string} = useParams();
  if (id?.toLowerCase() === 'create') {
    id = undefined;
  }

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();
  const [entityId, setEntityId] = useState<string>();
  const [loading, setLoading] = useState<boolean>(id ? true : false);

  useEffect(() => {
    const getAffiliations = async (seniorId: string) => {
      try {
        const result: {totalCount: number; data: Array<AffiliationInfo>} =
          await UsersRepository.instance.getUserAffiliations(seniorId, 0, 10);
        if (result.data.length > 0) {
          setEntityId(result.data[0].entity.id);
          setLoading(false);
        }
      } catch (e) {
        console.error(e);
        setLoading(false);
      }
    };

    if (id) {
      getAffiliations(id);
    }
  }, [id]);

  if (loading) {
    return (
      <Stack
        height={`calc(100vh - 108px - (2 * 20px) - 70px - 40px)`}
        sx={{justifyContent: 'center', alignItems: 'center'}}
      >
        <LoadingContent />
      </Stack>
    );
  }

  return (
    <UserSeniorForm
      userFormType={UserFormType.CreateEditRemoveSenior_SystemAdministrator}
      redirectUrl={id ? `${url.replace(`/${id}`, '')}` : `${url.replace('/create', '')}`}
      entityId={entityId}
    />
  );
}
